import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TNinusiInfoGetRes,
  TNinusiListGetReq,
  TNinusiRegisterPostReq,
  TNinusiUpdatePutReq,
} from "./TNinusi"

/**
 * 荷主マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class NinusiService
 * @extends {ConnectApi}
 */
export default class NinusiService extends ConnectApi {
  /**
   * 一覧取得
   *
   * @param {TNinusiListGetReq} params
   * @param {(param: TApiResponse<TNinusiInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TNinusiInfoGetRes[]>) => any} reject
   * @memberof NinusiService
   */
  getList = async (
    params: TNinusiListGetReq,
    resolve?: (param: TApiResponse<TNinusiInfoGetRes[]>) => any,
    reject?: (param: TApiResponse<TNinusiInfoGetRes[]> | undefined) => any
  ) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TNinusiInfoGetRes[]>> =
        await this.getInner(`/master/ninusi`, params)
      return res.data
    } catch (err) {
      if (typeof err !== "object" || err == null) throw err
      const error = err as TApiResponse<TNinusiInfoGetRes[]>
      throw reject ? reject(error) : error
    }
  }
  /**
   * 単体取得
   *
   * @param {id} params
   * @returns TNinusiInfoGetRes
   * @memberof NinusiService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      //API呼出
      const res: AxiosResponse<TApiResponse<TNinusiInfoGetRes>> =
        await this.getInner(`/master/ninusi/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体登録
   *
   * @param {TNinusiRegisterPostReq} data
   * @memberof NinusiService
   */
  post = async (data: TNinusiRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/ninusi/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体更新
   *
   * @param {id} params
   * @param {TNinusiRegisterPostReq} data
   * @memberof NinusiService
   */
  put = async (id: number, data: TNinusiUpdatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/ninusi/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
